'use strict';

module.exports = /*@ngInject*/ function () {
    return {
        restrict: 'EA',
        require: '^ngModel',
        scope: {
            ngModel: '=',
            legendItemClick: '&'
        },
        template: [`
        `

        ].join(''),

        link: function (scope, iElement, iAttrs, ngModel) {

            scope.toggleLegendItem = function (item) {
                item.visible = !item.visible;
                scope.legendItemClick({"name": item.name, "visible": item.visible});
            };

            scope.$watch('ngModel', function (modl) {
                scope.legendData = modl;
            });
        }
    };
};